"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProgrammeConflicts = exports.dayShift = exports.isAllTimePositive = exports.dayIntToJson = exports.isEveryDay = exports.generateDefaultCycle = exports.getTimeDifferenceInMinutes = void 0;
const tslib_1 = require("tslib");
const dayjs_1 = tslib_1.__importDefault(require("dayjs"));
const customParseFormat_1 = tslib_1.__importDefault(require("dayjs/plugin/customParseFormat"));
const duration_1 = tslib_1.__importDefault(require("dayjs/plugin/duration"));
const IrrigatorHelper_1 = require("./IrrigatorHelper");
dayjs_1.default.extend(duration_1.default);
dayjs_1.default.extend(customParseFormat_1.default);
const MINUTES_IN_DAY = 24 * 60; //1440
const getTimeDifferenceInMinutes = (time1, time2) => {
    let minuteDifference = time2.diff(time1, 'minute');
    if (minuteDifference < 0) {
        minuteDifference += MINUTES_IN_DAY;
    }
    return minuteDifference;
};
exports.getTimeDifferenceInMinutes = getTimeDifferenceInMinutes;
const generateDefaultCycle = (existingDayMask = [], groupSize) => {
    return { start_time: Array(groupSize).fill('00:00'), duration: Array(groupSize).fill(1), dayMask: existingDayMask };
};
exports.generateDefaultCycle = generateDefaultCycle;
const isEveryDay = (dayMask) => {
    if (dayMask.length === 7) {
        return true;
    }
    else if (dayMask.length === 1 && dayMask[0] === 7) {
        return true;
    }
    return false;
};
exports.isEveryDay = isEveryDay;
const dayIntToJson = (days) => {
    if (days.length === 1 && days[0] === 7) {
        return {
            sunday: true,
            monday: true,
            tuesday: true,
            wednesday: true,
            thursday: true,
            friday: true,
            saturday: true,
        };
    }
    return {
        sunday: days.includes(0),
        monday: days.includes(1),
        tuesday: days.includes(2),
        wednesday: days.includes(3),
        thursday: days.includes(4),
        friday: days.includes(5),
        saturday: days.includes(6),
    };
};
exports.dayIntToJson = dayIntToJson;
const isAllTimePositive = (timestampList, indexPoint) => {
    let compareList = [...timestampList];
    if (indexPoint) {
        compareList = timestampList.slice(0, indexPoint + 1);
    }
    return compareList.every((val, i) => i === 0 || timestampList[i - 1].localeCompare(val) !== 1);
};
exports.isAllTimePositive = isAllTimePositive;
const dayShift = (days, shiftDirection) => {
    // catch to make sure all days don't get shifted
    if (days.length === 7 || (days.length === 1 && days[0] === 7)) {
        return [0, 1, 2, 3, 4, 5, 6];
    }
    switch (shiftDirection) {
        case 'DOWN':
            return days.map((day) => (day + 6) % 7);
        case 'UP':
            return days.map((day) => (day + 1) % 7);
    }
};
exports.dayShift = dayShift;
const getProgrammeConflicts = (programme) => {
    // rollover of each cycle
    const cycleRollover = programme.cycles.map((_, i) => programme.getRollover(i));
    let inputs = [];
    programme.cycles.forEach((cycle, cycleIndex) => {
        cycle.start_time.forEach((start, startIndex) => {
            var _a;
            ;
            ((_a = cycle.dayMask) !== null && _a !== void 0 ? _a : programme.dayMask).forEach((day) => {
                const shiftedDay = cycleRollover[cycleIndex][startIndex] ? (day + 1) % 7 : day;
                inputs.push({
                    day: shiftedDay,
                    time: start,
                    type: 'START',
                    source: {
                        cycle: cycleIndex,
                        order: startIndex,
                    },
                });
                inputs.push({
                    day: shiftedDay,
                    time: (0, IrrigatorHelper_1.getEndTime)(start, cycle.duration[startIndex]),
                    type: 'END',
                    source: {
                        cycle: cycleIndex,
                        order: startIndex,
                    },
                });
            });
        });
    });
    inputs = inputs.sort((a, b) => {
        const dayDiff = a.day - b.day;
        if (dayDiff === 0) {
            const timeDiff = a.time.localeCompare(b.time);
            if (timeDiff === 0) {
                return a.type.localeCompare(b.type);
            }
            return a.time.localeCompare(b.time);
        }
        else {
            return dayDiff;
        }
    });
    const notNextTo = [];
    for (let i = 0; i < inputs.length; i++) {
        const current = inputs[i];
        if (!!!(i + 1 < inputs.length && isSameSource(inputs[i + 1].source, current.source))) {
            notNextTo.push(current);
        }
        else {
            i++;
        }
    }
    const checkLength = notNextTo.length;
    const overlaps = [];
    notNextTo.forEach((option, i) => {
        if (option.type === 'START') {
            const local = { from: option.source, conflicts: [] };
            let checkIndex = i;
            while (true) {
                checkIndex = (checkIndex + 1) % checkLength;
                let nextSeen = notNextTo[checkIndex];
                if (nextSeen.type === 'END' && isSameSource(nextSeen.source, option.source)) {
                    if (local.conflicts.length !== 0) {
                        overlaps.push(local);
                    }
                    break;
                }
                else if (checkIndex === i) {
                    // checkIndex === i failsafe to ensure it does end
                    break;
                }
                else {
                    // add the overlap
                    const found = local.conflicts.find((val) => val.cycle === nextSeen.source.cycle && val.order === nextSeen.source.order);
                    if (found === undefined) {
                        local.conflicts.push(nextSeen.source);
                    }
                }
            }
        }
    });
    console.log('overlaps', overlaps);
    return overlaps;
};
exports.getProgrammeConflicts = getProgrammeConflicts;
const isSameSource = (source1, source2) => {
    return source1.cycle === source2.cycle && source1.order === source2.order;
};
